export default {
  getShowLogoutModal: (state) => state.showLogoutModal,
  getShowAuthorizationModal: (state) => state.showAuthorizationModal,
  getAuthorizationStatus: (state) => state.isAuthorized,
  getMerchantAccess: (state) => state.merchantAccess,
  getMerchantPhoneNumber: (state) => state.merchantPhoneNumber,
  getEvtSelectRowDropDownStateValue: (state) => state.evtSelectRowDropDownStateValue
}
